import angular from 'angular';
import MyPricePointMixWidgetComponent from './my-price-point-mix-widget-component';

export default angular.module('my-price-point-mix-widget', []).component('myPricePointMixWidget', new MyPricePointMixWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/my-price-point-mix/my-price-point-mix-widget-module.js